/* biome-ignore-all lint/suspicious/noConsole: Console logging is intentional in this analytics implementation */
import type {
  Analytics,
  Company,
  SharedProperties,
  User,
} from "../core/Analytics";
import type { BaseEvent } from "../core/BaseEvent";

export class ConsoleAnalytics<
  TEvent extends BaseEvent<object> = BaseEvent<object>,
> implements Analytics<TEvent>
{
  async alias(oldId: string, newId: string) {
    console.log("[Analytics] Alias:", oldId, newId);
  }

  async identify(user: User): Promise<void> {
    console.log("[Analytics] Identify:", user);
  }

  page(): void {
    console.log(
      "[Analytics] Page View:",
      `${window.location.pathname}${window.location.search}${window.location.hash}`
    );
  }

  track(event: TEvent): void {
    console.log("[Analytics] Track:", event);
  }

  register(sharedProperties: SharedProperties): void {
    console.log("[Analytics] Register:", sharedProperties);
  }

  identifyCompany(company: Company): void {
    console.log("[Analytics] Identify Company:", company);
  }
}
